<template>
  <div class="table_wrap">
    <div class="c_table_wrap table_search_wrap">
      <div class="select_wrap mb11">
        <div class="filter-select-div el-div-long mb11">
          <span class="filter-select-span mr20">작성일</span>
          <span class="el-date-icon mr2" :class="checkFilterData() ? 'iconMove' : ''">
                        <span class="el-date-icon-img"></span>
                        <el-date-picker
                            type="daterange"
                            class="el-date-common"
                            start-placeholder="시작 날짜"
                            range-separator="~"
                            end-placeholder="끝 날짜"
                            format="yyyy-MM-dd"
                            prefix-icon=" "
                            v-model="filterDate"
                            value-format="yyyy-MM-dd"
                            @change="setFilterFunc('wrcr',filterDate)"
                            clear-icon="el-icon-circle-close el-clear-icon"
                        >
                        </el-date-picker>
                    </span>
        </div>
        <div class="board_check_list" v-if="this.$route.query.tab === 'donate'" >
          <el-checkbox @change="checkList()"  >메인&상단 노출리스트</el-checkbox>
        </div>
        <div class="board_check_list" v-if="this.$route.query.tab === 'news'" >
          <el-checkbox @change="checkList()" >메인 노출리스트</el-checkbox>
        </div>
        <br/>
        <div class="filter-select-div dp-block mr16">
          <span class="filter-select-span mr24">제목</span>
          <!--                                <div class="search">-->

          <el-input
              class="table_s_input search-input mr7"
              v-model="searchInput"
              size=""
              placeholder="검색어를 입력해주세요."
              maxLength="40"
              @keyup.enter.native="setFilterFunc('su', searchInput)"
          >
          </el-input>
          <el-button class="search-button" @click="setFilterFunc('su', searchInput)">
            검색
          </el-button>
          <div class="filter-show-count">
            <el-select v-model="size" @change="changePage('size', size)">
              <el-option v-for="(sizeData) in sizeList" :key="`size${sizeData}`" :value="sizeData"
                         :label="`${sizeData}개씩 보기`"></el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import util from "@/mixins/util";
import boardUtil from "@/components/board/boardUtil";

const {filterConfig} = boardUtil
export default {
  name: "BoardFilterDefaultLayout",
  mixins: [],
  components: {},
  provide() {
    return {}
  },
  inject: {
    setPage: {
      default: () => {
      }
    },
    boardListSetData: {
      default: () => {
      }
    },
    setFilter: {
      default: () => {
      }
    },
  },
  props: {
    filterData: {
      default: () => {
        return {}
      }
    },
    paginationData: {
      type: Object,
      default: {
        total: 0,
        page: 0,
        size: 0,
      }
    },
  },
  data() {
    return {
      searchInput: '',
      filterDate: [],
      size: 10,
      sizeList: [10, 30, 50],
      filterStartDate: '',
      filterEndDate: '',
      check:false
    }
  },
  created() {
  },
  mounted() {
    this.setterFilterDataInData();
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    setterFilterDataInData() {
      let classnames = Object.keys(this.filterData);
      classnames.forEach(classname => {
        let obj = this.filterData[classname];
        let type = filterConfig[obj.key].type;
        if (this.hasOwnProperty(classname)) {
          // this[classname] =
          if (type == 'query') {
            this[classname] = obj.query;
          } else if (type === 'between') {
            this[classname] = [obj.start, obj.end];
          } else if (type === 'match') {
            if (isNaN(obj.value)) {
              this[classname] = obj.value;
            } else {
              this[classname] = Number(obj.value);
            }

          }

        }
      })
      this.size = this.paginationData.size;
    },
    setFilterFunc(key, value) {
      this.setFilter(key, value);
    },
    checkList(){
      this.check = !this.check;
      if(this.check){
        this.setFilter('ni', 1);
      }else{
        this.setFilter('ni', '');
      }
    },
    checkFilterData() {
      return this.filterDate != null && this.filterDate.length > 0;
    },
    changePage(key, value) {
      this.setPage('page', 1);
    },
  },
  watch: {},
}
</script>

<style scoped>

</style>